import { render, staticRenderFns } from "./BarcodeQuaggaComponent.vue?vue&type=template&id=4f7a91a2&scoped=true&"
import script from "./BarcodeQuaggaComponent.vue?vue&type=script&lang=js&"
export * from "./BarcodeQuaggaComponent.vue?vue&type=script&lang=js&"
import style0 from "./BarcodeQuaggaComponent.vue?vue&type=style&index=0&id=4f7a91a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7a91a2",
  null
  
)

export default component.exports